import { PARTY_KIND } from '../constants/partyKindLookupConstants';

export const getPartyName = (row) => {
  const { PartyType, PlaceName, PersonName } = row;
  switch (PartyType) {
    case PARTY_KIND.PLACE:
      return PlaceName;
    case PARTY_KIND.PERSON:
      return PersonName;
    default:
      return '';
  }
};

export const getPartyID = (row) => {
  const { PartyType, PlaceID, PersonID } = row;
  switch (PartyType) {
    case PARTY_KIND.PLACE:
      return PlaceID;
    case PARTY_KIND.PERSON:
      return PersonID;
    default:
      return '';
  }
};
